var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"gst-event-status-chip__postponed",attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.$t('postponed'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }